import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Radio button elements to display. Typically a set of RadioButton components */
  children: PropTypes.node.isRequired,
  /** Legend/Title for the group, describing the purpose of the radio buttons */
  legend: PropTypes.node.isRequired,
  /** Layout of the radio buttons */
  variant: PropTypes.oneOf(['', 'horizontal'])
};
function RadioButtonGroup(_ref) {
  var children = _ref.children,
    legend = _ref.legend,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? '' : _ref$variant;
  var isHorizontal = variant === 'horizontal';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "radio-button-group",
    "data-testid": "radio-button-group"
  }, /*#__PURE__*/React__default.createElement("fieldset", {
    "data-horizontal": isHorizontal ? true : undefined
  }, /*#__PURE__*/React__default.createElement("legend", {
    className: "radio-button-group-title"
  }, legend), isHorizontal ? /*#__PURE__*/React__default.createElement("div", {
    className: "radio-button-group-content",
    "data-testid": "radio-button-group-content"
  }, children) : children));
}
RadioButtonGroup.propTypes = propTypes;

export { RadioButtonGroup as default };
//# sourceMappingURL=RadioButtonGroup.js.map
